var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_c('div',{staticClass:"notfound-404"},[_c('h1',[_vm._v("404")])]),_c('h3',[_vm._v("Η σελίδα που ζητήσατε δεν βρέθηκε.")]),_c('h3',[_vm._v("Δοκιμάστε να περιηγηθείτε από τις επιλογές του μενού.")])])])
}]

export { render, staticRenderFns }